import React from 'react';

import { italicsParser, urlParser, PARSING_TYPES } from 'utils/textParsers';

function MarkdownParser({ children, parsers }) {
  const parsedItalics = italicsParser(children);
  const parsedData = parsedItalics.flatMap((item) => urlParser(item, true));

  if (parsedData.length > 1) {
    return parsedData.map(str => {
      if (str.type === PARSING_TYPES.URL) {
        return parsers.link(str);
      }

      if (str.type === PARSING_TYPES.ITALICS) {
        return parsers.italics(str);
      }

      return str.text;
    });
  }

  return children;
}

const parsers = {
  link: ({ text, url }) => <a key={url} className="link" rel="noopener noreferrer" target="_blank" href={url}>{text}</a>,
  italics: ({ text }) => <em key={text}>{text}</em>
}

MarkdownParser.defaultProps = {
  parsers
};

export default MarkdownParser;
